export default __webpack_public_path__ + "static/media/crypto-assets.17e74ae5.png";